import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components';
import { DisplayUtils } from '../../utils';
import ContentLayout from '../../layouts/contentLayout/ContentLayout';
import './Sitemap.scss';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const Sitemap = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const sitemapLinks = [
    {
      label: t('Menu.profile'),
      url: "/profile",
      sublinks: [
        {
          label: t('Menu.change-language'),
          url: "/profile/language",
        }
      ]
    },
    {
      label: t('Menu.how-works'),
      url: "/how-works"
    },
    {
      label: t('Menu.petitions'),
      url: "/petitions"
    },
    {
      label: t('Menu.notifications'),
      url: "/notifications"
    },
    {
      label: t('Menu.shops'),
      url: "/shops",
      sublinks: [
        {
          label: t('Menu.phisicalShopPoints'),
          url: "/shops",
        },
        {
          label: t('Menu.onlineShopPoints'),
          url: "/online-shops",
        }
      ]
    },
    {
      label: t('Menu.information'),
      url: "/information"
    },
    {
      label: t('Footer.legal'),
      url: "/legal"
    },
    {
      label: t('Footer.privacy'),
      url: "/privacy"
    },
    /*{
      label: t('Footer.cookies'),
      url: "/cookies"
    },*/
    {
      label: t('Footer.sitemap'),
      url: "/sitemap"
    },
    {
      label: t('Footer.accessibility'),
      url: "/accessibility"
    },
    {
      label: t('Footer.apps'),
      url: "https://bonoculturajoven.gob.es/apps-moviles.html",
      isExternal: true
    }
  ];

  return (
    <ContentLayout>
      <div className="Sitemap">
        <div className="w-100 d-flex justify-content-center">
          {!DisplayUtils.isMobile() ? (
            <img src="/misc/icons/complete_logo_white.svg" alt="shop-icon" className="Sitemap__logo" />
          ) : (
            <div className="Sitemap__title">
              <Button
                icon="/misc/icons/arrow-left-blue.svg"
                action={() => history.goBack()}
                className="Button__transparent p-2 button-only-icon me-2"
                a11y={t('Globals.return')}
              />
              <h1>{t('Sitemap.head')}</h1>
            </div>
          )}
        </div>
        <div className="w-100 d-flex justify-content-center">
          <div className="Sitemap__container">
            {!DisplayUtils.isMobile() && (
              <div className="Sitemap__container__title">
                <Button
                  icon="/misc/icons/arrow-left-pink.svg"
                  action={() => history.goBack()}
                  className="Button__transparent p-2 button-only-icon me-2"
                  a11y={t('Globals.return')}
                />
                <h1>{t('Sitemap.head')}</h1>
              </div>
            )}
            <div className='Sitemap__container__content'>
              <div className="Sitemap__container__content__description">
                <ul>
                  {sitemapLinks.map((link, index) => (
                    <li key={index}>
                      { link.isExternal ? <a href={link.url} target='_blank' rel='noreferrer'>{link.label}</a> : <Link to={link.url}>{link.label}</Link> }
                      {
                        link.sublinks &&
                        <ul>
                          {link.sublinks.map((sublink, index) => (
                            <li key={index}>
                              <Link to={sublink.url}>{sublink.label}</Link>
                            </li>
                          ))}
                        </ul>
                      }
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default Sitemap;
